import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-wrapper',
  template: ` <p-divider
      *ngIf="
        props && props.attributes && props.attributes['separator']
      "
    ></p-divider>
    <div class="field p-fluid mb-3 mt-1">
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label class="block"
        >{{ field.templateOptions.label
        }}{{ field.templateOptions.required ? ' *' : '' }}</label
      >
      <ng-container #fieldComponent></ng-container>
      <div
        *ngIf="
          props && props.attributes && props.attributes['warning']
        "
        class="text-sm my-1 text-yellow-400"
      >
        <span
          class="font-bold"
          i18n
          >Warnung:</span
        >
        {{ props.attributes['warning'] }}
      </div>
    </div>`,
})
export class FieldWrapperComponent extends FieldWrapper {}
